<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <section
          v-if="Object.keys(mergeRequest)?.length > 0"
          class="merge-request-overview-layout"
        >
          <merge-request-header
            class="merge-request-overview-layout__header"
          ></merge-request-header>
          <merge-request-navigation-bar
            class="merge-request-overview-layout__navigation"
            :show-ci="isCiCdEnabled"
            :show-security="getActionAvailabilityFlag(ACTION_ENUM.READ_VULNERABILITY)"
          ></merge-request-navigation-bar>
          <div class="merge-request-overview-layout__content">
            <router-view></router-view>
          </div>
        </section>
        <section
          v-else
          class="merge-request-overview-layout"
        >
          <pacman-loader />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import MergeRequestHeader from '@shared/modules/merge-request/components/item/MergeRequestHeader';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import MergeRequestService from '@shared/modules/merge-request/merge-request.service';
// eslint-disable-next-line max-len
import MergeRequestNavigationBar from '@shared/modules/merge-request/components/item/MergeRequestNavigationBar';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'MergeRequestOverviewLayout',
  components: { MergeRequestHeader, PacmanLoader, MergeRequestNavigationBar },
  data() {
    return {};
  },
  computed: {
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    mergeRequestId() {
      return this.$route.params?.id;
    },
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest || {};
    },
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    isCiCdEnabled() {
      return this.getActionAvailabilityFlag(ACTION_ENUM.READ_CI_CD);
    }
  },
  mounted() {
    this.getMergeRequest();
  },
  methods: {
    getMergeRequest() {
      MergeRequestService.getMergeRequest(this.alias, this.projectAlias, this.mergeRequestId);
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request-overview-layout';

#{$this} {
  min-height: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;

  #{$this}__content {
    min-height: 200px;
    position: relative;
  }
}
</style>
